import { colorsPalettes } from "@similarweb/styles";

export const GROWTH_OVERVIEW_EXCEL_ENDPOINT = "/api/Industries/Benchmark/GrowthOverview/Excel";

export const GROWTH_OVERVIEW_QUERY_KEY = "segmentation-growth-overview";

export const MIN_MONTHS_FOR_QUARTERLY = 12;
export const SEARCH_DEBOUNCE_MS = 250;
export const DOMAIN_LIST_PREVIEW_LIMIT = 12;
export const DOMAIN_LIST_EXPANDED_LIMIT = 100;
export const DOMAIN_LIST_SHOW_MORE_MIN_REMAINING = 3;
export const DOMAIN_PAGE_SIZE = 100;
export const GROWTH_OVERVIEW_CATEGORY_PAGE_SIZE = 5;

export const GrowthOverviewMetric = {
    Visits: "visits",
    Unique: "unique",
} as const;

export type GrowthOverviewMetric = (typeof GrowthOverviewMetric)[keyof typeof GrowthOverviewMetric];

export const GrowthOverviewGranularity = {
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    Weekly: "Weekly",
} as const;

export type GrowthOverviewGranularity = (typeof GrowthOverviewGranularity)[keyof typeof GrowthOverviewGranularity];

export const GrowthOverviewSortBy = {
    TotalVisits: "TotalVisits",
    UniqueUsers: "UniqueUsers",
} as const;

export type GrowthOverviewSortBy = (typeof GrowthOverviewSortBy)[keyof typeof GrowthOverviewSortBy];

/** Background for expanded industry / sub-industry rows */
export const GROWTH_OVERVIEW_EXPANDED_ROW_HIGHLIGHT = colorsPalettes.sky[200];
export const GROWTH_OVERVIEW_EXPANDED_ROW_ACCENT = colorsPalettes.blue[400];

/** Sticky name/summary widths are fixed; period columns use minmax(period, 1fr) in the grid. */
export const GROWTH_OVERVIEW_COLUMN_WIDTHS = {
    name: 320,
    summary: 140,
    /** Fits monthly labels (e.g. "Jan 2026") plus sort icon; also used as horizontal scroll step when overflow. */
    period: 108,
} as const;
